exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.youtube-detail-label[data-v-ece7858c] {\n  width: 80px;\n  color: grey;\n  font-size: 12px;\n  text-align: left;\n}\n.youtube-detail-value[data-v-ece7858c] {\n  font-size: 12px;\n  width: 300px;\n  text-align: left;\n}\n.youtube-list__cell-channel[data-v-ece7858c] {\n  width: 300px;\n}\n.youtube-list__cell-views[data-v-ece7858c] {\n  width: 80px;\n}\n", ""]);

// exports
